import PropTypes from "prop-types";
import React from "react";
import {
    Button,
    Form,
} from "semantic-ui-react";
import Counters from "./util/Counters";
import Media from "./util/Media";

class RegionForm extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            mode: "edit",
            counters: 0,
            notes: "",
            file: null,
        };
    }

    submit(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ mode: "saving" });
        const data = {};
        if (this.acceptNotes()) {
            data.notes = this.state.notes || "";
        }
        if (this.acceptCounters()) {
            data.counters = this.state.counters || 0;
        }
        if (this.acceptFile() && this.state.file) {
            data.file = this.state.file;
        }

        this.props.createSubmission(data)
            .then(() =>
                this.setState({
                    mode: "edit",
                    counters: 0,
                    notes: "",
                    file: null,
                }),
            )
            .catch(e => {
                console.error("error saving submission", e);
                alert("there was an error: " + e);
                this.setState({
                    mode: "edit",
                });
            });
    }

    counters(e, i) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            counters: this.state.counters + i,
        });
    }

    acceptFile() {
        return this.props.region.accept.indexOf("file") >= 0;
    }

    acceptNotes() {
        return this.props.region.accept.indexOf("notes") >= 0;
    }

    acceptCounters() {
        return this.props.region.accept.indexOf("counters") >= 0;
    }

    render() {
        const {
            mode,
            counters,
            notes,
            file,
        } = this.state;
        if (mode === "saving") {
            return <p>Saving...</p>;
        }
        return <Form onSubmit={(e) => this.submit(e)}>
            {this.acceptCounters() && <Form.Field>
                <div style={{
                    position: "absolute",
                    top: "0.4em",
                    right: 0,
                }}>
                    {[10, 1, -1, -10].map(n =>
                        <Counters key={n} n={n} delta
                                  onClick={e => this.counters(e, n)}
                                  className="smash-icon"
                        />,
                    )}
                </div>
                <input value={counters}
                       onChange={e => {
                           const asInt = parseInt(e.target.value, 10);
                           if (!isNaN(asInt)) {
                               this.setState({ counters: asInt });
                           }
                       }}
                       step={1}
                />
            </Form.Field>}
            {this.acceptFile() && <Form.Field>
                <Media value={file}
                       onChange={f => this.setState({ file: f })} />
            </Form.Field>}
            {this.acceptNotes() && <Form.Field>
                <textarea value={notes || ""}
                          onChange={e => this.setState({ notes: e.target.value })}
                          style={{ minHeight: "6em" }}
                          rows={4}
                />
            </Form.Field>}
            <Form.Field control={Button.Group}>
                <Button icon="save"
                        content="Submit"
                        compact
                />
            </Form.Field>
        </Form>;
    }
}

RegionForm.propTypes = {
    context: PropTypes.object.isRequired,
    region: PropTypes.object.isRequired,
    createSubmission: PropTypes.func.isRequired,
};

export default RegionForm;



// WEBPACK FOOTER //
// ./src/RegionForm.js